/**
 * Validated web env. The architecture §15.2 rule (no `process.env` outside
 * config/env) extends to `import.meta.env` here — every consumer reads from
 * the typed `WEB_ENV` object below.
 */
import { loadWebEnv } from "@flint/config";

export const WEB_ENV = loadWebEnv(import.meta.env as unknown as Record<string, string | undefined>);
